(function () {
  /* 15/10/2026 (Luca: «per il bug di aggiungi al carrello puoi pensarci tu?», dal check del 14/10) · due tocchi veloci su «Aggiungi
     al carrello» mettevano quantità 2: il pulsante restava toccabile mentre /cart/add.js lavorava. Ogni aggiunta di questo file accende
     .is-loading sul pulsante prima della chiamata e lo spegne alla risposta: finché è acceso, il secondo tocco e il secondo invio del
     form si fermano qui, in cattura sul documento, prima di ogni altro ascoltatore (anche quello dei passetti e la barra fissa, che
     tocca il pulsante della scheda). Dopo la risposta si può aggiungere di nuovo. */
  var IN_VOLO = '[data-gg-pdp-atc].is-loading, button[type="submit"].is-loading';
  function occupato(el) {
    var f = el && (el.form || (el.closest && el.closest('form')));
    return !!((f && f.querySelector(IN_VOLO)) || (el && el.classList && el.classList.contains('is-loading')));
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-gg-pdp-atc], form[data-gg-ajax] button[type="submit"]');
    if (b && occupato(b)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('.gg-pdp-form, form[data-gg-ajax]') && f.querySelector(IN_VOLO)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  function formatMoney(cents) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function initPdp(root) {
    if (!root || root.dataset.ggPdpInit) return;
    root.dataset.ggPdpInit = 'true';

    var configEl = root.querySelector('[data-gg-pdp-config]');
    var config = configEl ? JSON.parse(configEl.textContent) : null;
    var variantIdInput = root.querySelector('[data-gg-pdp-variant-id]');
    var priceEls = root.querySelectorAll('[data-gg-pdp-price]');
    var priceCompareEls = root.querySelectorAll('[data-gg-pdp-price-compare]');
    var priceSaveEls = root.querySelectorAll('[data-gg-pdp-price-save]');
    var ctaButtons = root.querySelectorAll('[data-gg-pdp-atc]');
    var form = root.querySelector('.gg-pdp-form');
    var selected = {};

    // Card upsell con prodotto collegato (checkbox + select): il totale sul
    // CTA principale deve contarne il prezzo quando e' spuntata.
    var bupAtcCard = root.querySelector('.gg-pdp-bup--atc');
    var bupAtcCheck = bupAtcCard && bupAtcCard.querySelector('[data-gg-bup-check]');
    var bupAtcSel = bupAtcCard && bupAtcCard.querySelector('[data-gg-bup-variant]');

    function getBupAtcPriceCents() {
      if (!bupAtcCheck || !bupAtcCheck.checked) return 0;
      var opt =
        bupAtcSel && bupAtcSel.tagName === 'SELECT'
          ? bupAtcSel.options[bupAtcSel.selectedIndex]
          : bupAtcSel;
      var cents = opt && opt.dataset ? parseInt(opt.dataset.priceCents, 10) : NaN;
      return isNaN(cents) ? 0 : cents;
    }

    if (config) {
      config.options.forEach(function (name, i) {
        var key = 'option' + (i + 1);
        var first = root.querySelector('[data-gg-pdp-option="' + (i + 1) + '"] .is-selected');
        if (first) selected[key] = first.dataset.value;
      });
    }

    function findVariant() {
      if (!config) return null;
      return config.variants.find(function (v) {
        return Object.keys(selected).every(function (k) {
          return v[k] === selected[k];
        });
      });
    }

    function updateVariant() {
      if (!config) return;
      var variant = findVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      // Se l'upsell bundle è spuntato, mostra il prezzo dell'upsell
      // invece di quello della variante, così il prezzo resta coerente
      // con lo stato della checkbox anche al cambio variante.
      var price =
        bupCheck && bupCheck.checked && config.upsellPrice
          ? config.upsellPrice
          : variant.price;
      priceEls.forEach(function (el) {
        el.textContent = formatMoney(price);
      });

      // Prezzo di confronto + risparmio (doc "Bundle" 18/08, punto 2.2): il
      // prezzo grande si muove appena si sceglie il set, non solo al
      // carrello. Il confronto e il risparmio seguono sempre la variante
      // vera anche se l'upsell bundle e' spuntato (il bundle non c'entra
      // col compare_at_price della collanina).
      var hasCompare = variant.compareAtPrice && variant.compareAtPrice > variant.price;
      priceCompareEls.forEach(function (el) {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = formatMoney(variant.compareAtPrice);
      });
      priceSaveEls.forEach(function (el) {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = 'Risparmi ' + formatMoney(variant.compareAtPrice - variant.price);
      });

      // Il CTA dice il totale (prodotto + collanina se spuntata): deve
      // aggiornarsi subito al tocco della checkbox o del menu, altrimenti
      // spuntare la checkbox non ha un effetto visibile (doc Luca 18/08).
      var ctaTotal = variant.price + getBupAtcPriceCents();
      ctaButtons.forEach(function (btn) {
        btn.disabled = !variant.available;
        var label = btn.dataset.labelDefault || 'Aggiungi al carrello';
        btn.textContent = variant.available
          ? label + ' · ' + formatMoney(ctaTotal)
          : 'Esaurito';
      });
    }

    // Al cambio variante la galleria salta alla foto della variante (Marco
    // 10/08): se la variante ha una featured_media presente tra le thumbnail
    // si riusa il click sulla thumb — stesso meccanismo dell'utente, quindi
    // stato attivo, video e anteprima incisione restano coerenti. Senza
    // media associata (o senza thumbnail, prodotti con un solo media) non
    // succede niente.
    function syncGalleryToVariant() {
      var variant = findVariant();
      if (!variant || !variant.featured_media) return;
      // 7/10/2026 (blocco 3): la galleria a slide del 6/10 scorre fino alla foto della variante (i set: collana, bracciale, tutti e due)
      var bin = root.querySelector('[data-gp-gal]');
      if (bin) {
        var slide = bin.querySelector('.gp-gal-slide[data-media-id="' + variant.featured_media + '"]');
        if (slide) bin.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        return;
      }
      var thumb = root.querySelector(
        '[data-gg-pdp-gallery-thumb][data-media-id="' + variant.featured_media + '"]'
      );
      if (thumb && !thumb.classList.contains('is-active')) thumb.click();
    }

    // ".gg-pdp-bundle-row" e' la riga verticale dei prodotti bundle (Sole,
    // Luna, Sole+Luna...), stesso gruppo/comportamento di ".gg-pdp-var".
    var OPTION_BTN_SELECTOR = '.gg-pdp-var, .gg-pdp-bundle-row';
    root.querySelectorAll('[data-gg-pdp-option]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest(OPTION_BTN_SELECTOR);
        if (!btn || btn.disabled) return;

        // 11/10/2026: il Liquid accende la scelta di partenza con «is-selected on» e il CSS colora tutte e due: togliendo solo
        // is-selected, «Tutti e due» restava acceso accanto a Collana (Luca, dall'editor). Si spengono e si accendono insieme.
        group.querySelectorAll(OPTION_BTN_SELECTOR).forEach(function (b) {
          b.classList.remove('is-selected', 'on');
        });
        btn.classList.add('is-selected', 'on');

        var pos = parseInt(group.dataset.ggPdpOption, 10);
        selected['option' + pos] = btn.dataset.value;
        updateVariant();
        syncGalleryToVariant();
        syncSet(btn.dataset.value || '');
      });
    });

    // 7/10/2026 (blocco 3) · i set: la frase «Uno per te, uno per chi ami» solo con «Tutti e due»; sulla Romantica il campo del testo
    // della collana e quello del bracciale seguono la versione scelta (Netlify, build_coppie.py). Il campo nascosto si disabilita,
    // così non viaggia nell'ordine e non blocca il form.
    function syncSet(value) {
      var isSet = value.indexOf('+') >= 0, low = value.toLowerCase();
      root.querySelectorAll('[data-gp-solo-set]').forEach(function (e) { e.hidden = !isSet; });
      root.querySelectorAll('[data-gp-testo]').forEach(function (box) {
        var mio = isSet || low.indexOf(box.dataset.gpTesto) >= 0;
        box.hidden = !mio;
        var inp = box.querySelector('[data-gp-testo-input]');
        if (inp) { inp.disabled = !mio; inp.required = mio; }
        var lab = box.querySelector('[data-gp-testo-label]');
        if (lab) lab.textContent = isSet ? lab.dataset.set : lab.dataset.solo;
      });
    }
    root.querySelectorAll('[data-gp-testo-input]').forEach(function (inp) {
      var conta = inp.parentElement.querySelector('[data-gp-conta]');
      if (conta) inp.addEventListener('input', function () { conta.textContent = inp.value.length + '/' + inp.maxLength; });
    });

    var galleryMain = root.querySelector('[data-gg-pdp-gallery-main]');
    root.querySelectorAll('[data-gg-pdp-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-gg-pdp-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');

        if (!galleryMain) return;
        var mediaType = thumb.dataset.mediaType;
        var src = thumb.dataset.src;
        var videoSrc = thumb.dataset.videoSrc;
        var alt = thumb.dataset.alt || '';

        if (mediaType === 'video' && videoSrc) {
          galleryMain.innerHTML =
            '<video src="' +
            videoSrc +
            '" controls playsinline poster="' +
            (src || '') +
            '" style="width:100%;height:100%;object-fit:cover;border-radius:20px;"></video>';
        } else if (src) {
          galleryMain.innerHTML =
            '<img src="' + src + '" alt="' + alt + '" loading="lazy">';
        }
      });
    });

    root.querySelectorAll('[data-gg-pdp-acc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.gg-pdp-acc__item').classList.toggle('is-open');
      });
    });

    root.querySelectorAll('[data-gg-pdp-faq]').forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });

    var igToggle = root.querySelector('[data-gg-pdp-ig-toggle]');
    var igShots = root.querySelector('[data-gg-pdp-ig-shots]');
    if (igToggle && igShots) {
      igToggle.addEventListener('click', function () {
        igShots.classList.toggle('is-open');
      });
    }

    var bupCheck = root.querySelector('[data-gg-pdp-bup]');
    if (bupCheck && config && config.upsellPrice) {
      bupCheck.addEventListener('change', function () {
        var variant = findVariant();
        if (!variant) return;
        var price = bupCheck.checked ? config.upsellPrice : variant.price;
        priceEls.forEach(function (el) {
          el.textContent = formatMoney(price);
        });
      });
    }

    if (bupAtcCard) {
      initBupAtc(bupAtcCard, updateVariant);
      if (bupAtcCheck) bupAtcCheck.addEventListener('change', updateVariant);
    }

    // Marco 27/08: submit del form SEMPRE via AJAX (bug segnalato su
    // "qualsiasi prodotto" — senza checkbox upsell spuntata il form faceva
    // submit nativo, apriva /cart intera invece del drawer). Unico listener
    // per tutti i casi: se la card upsell esiste ed e' spuntata usa la
    // logica bundle di prima, altrimenti aggiunta generica via FormData.
    initFormSubmit(form, bupAtcCard, bupAtcCheck, bupAtcSel);

    // Anteprima live del testo personalizzato sul ciondolo: mentre il cliente
    // scrive, la galleria mostra la foto "pulita" con il testo sovrapposto.
    var engraveInput = root.querySelector('.gg-pdp-engrave');
    var engraveStage = root.querySelector('[data-gg-engrave-stage]');
    if (engraveInput && engraveStage) {
      var engraveGallery = engraveStage.parentElement;
      var engraveText = engraveStage.querySelector('[data-gg-engrave-text]');
      var sizeFrac = parseFloat(engraveStage.dataset.size || '5.5') / 100;
      var maxWFrac = parseFloat(engraveStage.dataset.maxw || '24') / 100;
      var maxHFrac = parseFloat(engraveStage.dataset.maxh || '14') / 100;

      // Il testo va a capo dentro la larghezza massima (come dipinto sulla
      // targhetta) e il font scala finché il blocco non sta anche in altezza.
      var fitEngrave = function () {
        var w = engraveStage.clientWidth;
        if (!w) return;
        var maxW = w * maxWFrac;
        var maxH = w * maxHFrac;
        var fs = w * sizeFrac;
        engraveText.style.width = maxW + 'px';
        for (var i = 0; i < 12; i++) {
          engraveText.style.fontSize = fs + 'px';
          if (engraveText.scrollHeight <= maxH && engraveText.scrollWidth <= maxW + 1) break;
          fs *= 0.85;
        }
      };

      // Vincoli call 18/07 (collanina innamorati): a capo dopo 8 caratteri,
      // massimo 2 righe — se il testo non ci sta, l'input rifiuta i caratteri.
      var ENGRAVE_LINE_MAX = 8;
      var ENGRAVE_LINES_MAX = 2;
      var engraveWrap = function (str) {
        var words = String(str || '').trim().split(/\s+/).filter(Boolean);
        var lines = [];
        var cur = '';
        var push = function () { if (cur) { lines.push(cur); cur = ''; } };
        words.forEach(function (word) {
          var w = word;
          while (w.length > ENGRAVE_LINE_MAX) {
            push();
            lines.push(w.slice(0, ENGRAVE_LINE_MAX));
            w = w.slice(ENGRAVE_LINE_MAX);
          }
          if (!w) return;
          if (!cur) cur = w;
          else if (cur.length + 1 + w.length <= ENGRAVE_LINE_MAX) cur += ' ' + w;
          else { push(); cur = w; }
        });
        push();
        return lines;
      };
      var engraveLastValid = '';

      engraveInput.addEventListener('input', function () {
        var value = engraveInput.value.trim();
        var lines = engraveWrap(value);
        if (lines.length > ENGRAVE_LINES_MAX) {
          engraveInput.value = engraveLastValid;
          return;
        }
        engraveLastValid = engraveInput.value;
        if (!value) {
          engraveStage.hidden = true;
          return;
        }
        if (!engraveStage.isConnected) engraveGallery.appendChild(engraveStage);
        engraveText.textContent = lines.join('\n');
        engraveStage.hidden = false;
        fitEngrave();
      });

      // il click su una thumbnail riporta alla galleria normale
      root.querySelectorAll('[data-gg-pdp-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          engraveStage.hidden = true;
        });
      });

      window.addEventListener('resize', fitEngrave);
    }

    updateVariant();
  }

  // ------------------------------------------------------------------
  // Barra fissa "Aggiungi al carrello" (snippet gg-pdp-cartbar)
  //
  // Vale per tutti i template prodotto: scheda normale e i tre configuratori.
  // La barra riceve dal markup quale CTA osservare e da dove leggere il
  // totale, quindi non duplica né la validazione né il calcolo del prezzo:
  //  - il click sulla barra clicca la CTA vera della pagina, che valida e
  //    aggiunge al carrello come farebbe l'utente premendola;
  //  - il totale è uno specchio del nodo che la pagina aggiorna già.
  // ------------------------------------------------------------------
  function initCartbar(bar) {
    if (bar.dataset.ggCartbarInit) return;
    bar.dataset.ggCartbarInit = 'true';

    var cta = document.querySelector(bar.dataset.cartbarWatch || '');
    if (!cta) {
      // nessuna CTA in pagina: una barra che non sa cosa fare è peggio di niente
      bar.remove();
      return;
    }

    var btn = bar.querySelector('[data-gg-cartbar-cta]');
    if (btn) {
      btn.addEventListener('click', function () {
        cta.click();
      });
    }

    var totalEl = bar.querySelector('[data-gg-cartbar-total]');
    var totalSrc = bar.dataset.cartbarTotalFrom
      ? document.querySelector(bar.dataset.cartbarTotalFrom)
      : null;

    if (totalEl && totalSrc) {
      var syncTotal = function () {
        var text = totalSrc.textContent.trim();
        if (text) totalEl.textContent = text;
      };
      syncTotal();
      new MutationObserver(syncTotal).observe(totalSrc, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    // La barra si vede quando la CTA è fuori schermo — in qualunque direzione,
    // così su un riepilogo lungo il totale è sempre a portata. Se la CTA non è
    // renderizzata (step non attivo, configuratore ancora chiuso) resta
    // nascosta: negli step intermedi il totale sta già su "Passo successivo".
    // La soglia di scroll evita che su mobile la barra copra il fondo della
    // pagina già all'atterraggio, quando la CTA non è ancora stata vista.
    var SCROLL_MIN = 120;
    // 28/10/2026 (task 20 di post-go-live, Elisabetta: «mi si alza tutta la tastiera sopra lo spazio per scrivere»):
    // mentre si scrive in un campo la barra non si vede, perché sull'iPhone sale sopra la tastiera e copre il campo
    var CAMPO = 'input[type="text"], input:not([type]), input[type="email"], input[type="search"], textarea';
    var scrivendo = function () {
      var a = document.activeElement;
      return !!(a && a.matches && a.matches(CAMPO));
    };
    var refresh = function () {
      var rect = cta.getBoundingClientRect();
      var rendered = rect.width > 0 || rect.height > 0;
      var onScreen = rect.bottom > 0 && rect.top < (window.innerHeight || 0);
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > SCROLL_MIN;
      var show = rendered && !onScreen && scrolled && !scrivendo();
      bar.classList.toggle('is-visible', show);
      // serve a nascondere le altre barre fisse della pagina (vedi gg-pdp.css)
      document.body.classList.toggle('gg-cartbar-on', show);
    };

    var frame = null;
    var schedule = function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        refresh();
      });
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(schedule, { threshold: 0 }).observe(cta);
    }
    // il cambio di step non muove la CTA nel viewport, la fa apparire da
    // display:none: l'IntersectionObserver non lo segnala, il resize sì
    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(cta);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('focusin', function (e) {
      schedule();
      // e il campo toccato viene portato a metà dello spazio sopra la tastiera, quando la tastiera è già su
      if (e.target && e.target.matches && e.target.matches(CAMPO)) {
        setTimeout(function () {
          if (document.activeElement === e.target) e.target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 350);
      }
    });
    document.addEventListener('focusout', function () { setTimeout(schedule, 50); });
    refresh();
  }

  /* Card upsell con prodotto collegato: la checkbox (Luca, doc "Checkbox
     sull'upsell prezzo dinamico" 18/08) sostituisce il vecchio bottone
     "Aggiungi" — niente piu' due CTA identiche vicine. Qui solo select
     variante/foto e validazione del testo personalizzato: il submit del
     form (bundle se spuntata, generico altrimenti) e' unificato in
     initFormSubmit qui sotto. onPriceChange ricalcola il totale sul CTA
     principale. */
  function initBupAtc(card, onPriceChange) {
    var check = card.querySelector('[data-gg-bup-check]');
    var sel = card.querySelector('[data-gg-bup-variant]');
    if (!check || !sel) return;
    var price = card.querySelector('[data-gg-bup-price]');

    if (sel.tagName === 'SELECT') {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        if (price && opt.dataset.price) price.textContent = opt.dataset.price;
        // la foto della card segue la variante scelta (Marco 09/08)
        if (opt.dataset.image) {
          var foto = card.querySelector('.gg-pdp-bup-media img');
          if (foto) {
            foto.src = opt.dataset.image;
            foto.removeAttribute('srcset');
          }
        }
        if (onPriceChange) onPriceChange();
      });
    }

    var testo = card.querySelector('[data-gg-bup-text]');
    if (testo) {
      testo.addEventListener('input', function () {
        testo.classList.remove('is-error');
      });
    }
  }

  /* Submit del form principale, sempre via AJAX (Marco 27/08). Prima, senza
     la checkbox upsell spuntata (o senza card upsell del tutto — la
     maggioranza dei prodotti), il form faceva il suo submit nativo: bug
     segnalato su "qualsiasi prodotto", apriva /cart intera invece del
     drawer. Un solo listener per entrambi i casi:
     - checkbox spuntata: aggiunge il SET (prodotto + collanina, con le
       eventuali properties come il testo sul ciondolo) in un solo fetch;
     - altrimenti: aggiunta generica via FormData(form), cosi' viaggiano da
       soli anche i campi che le app iniettano nel form (Easify, personal.)
       senza doverli elencare a mano.
     In entrambi i casi apre il drawer via cart:refresh {open:true} (vedi
     cart-drawer.js). */
  function initFormSubmit(form, card, check, sel) {
    if (!form) return;
    var testo = card ? card.querySelector('[data-gg-bup-text]') : null;

    form.addEventListener('submit', function (evt) {
      var submitBtn = form.querySelector('[data-gg-pdp-atc]');
      var labelBase = submitBtn ? submitBtn.textContent : null;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      function finish(response) {
        return response
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            if (submitBtn) submitBtn.textContent = 'Aggiunto ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          })
          .catch(function () {
            if (submitBtn) submitBtn.textContent = 'Riprova';
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.classList.remove('is-loading');
              if (labelBase) setTimeout(function () { submitBtn.textContent = labelBase; }, 2500);
            }
          });
      }

      if (check && sel && check.checked && !check.disabled) {
        evt.preventDefault();

        // testo personalizzato obbligatorio quando il campo e' in card
        if (testo && !testo.value.trim()) {
          testo.classList.add('is-error');
          testo.focus();
          return;
        }

        var item = { id: Number(sel.value), quantity: 1 };
        if (testo) {
          item.properties = {};
          item.properties[testo.getAttribute('placeholder') || 'Testo'] = testo.value.trim();
        }

        // bundle: la collanina viaggia insieme al prodotto della pagina, nella
        // sua variante E con le sue properties (es. "Testo sul ciondolo") —
        // senza, la personalizzazione andrebbe persa
        var items = [];
        var madre = form.querySelector('[data-gg-pdp-variant-id]');
        if (madre && madre.value) {
          var mainItem = { id: Number(madre.value), quantity: 1 };
          var props = {};
          var campi = form.querySelectorAll('[name^="properties["]');
          var bloccato = false;
          campi.forEach(function (campo) {
            var nome = campo.name.slice(11, -1);
            var valore = (campo.value || '').trim();
            if (campo.required && !valore) {
              campo.focus();
              campo.classList.add('is-error');
              campo.addEventListener('input', function () { campo.classList.remove('is-error'); }, { once: true });
              bloccato = true;
              return;
            }
            if (valore) props[nome] = valore;
          });
          if (bloccato) return;
          if (Object.keys(props).length) mainItem.properties = props;
          items.push(mainItem);
        }
        items.push(item);

        if (submitBtn) submitBtn.classList.add('is-loading');
        finish(fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }));
        return;
      }

      evt.preventDefault();
      if (submitBtn) submitBtn.classList.add('is-loading');
      finish(fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }));
    });
  }

  function boot() {
    document.querySelectorAll('[data-gg-pdp-root]').forEach(initPdp);
    document.querySelectorAll('[data-gg-cartbar]').forEach(initCartbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ------------------------------------------------------------------
     6/10/2026 (Claude, blocco 2 del cantiere) · la scheda di Netlify: la galleria coi pallini, «Dettagli in», il blocco
     «La collana» e «Un ciondolino» (è il JS di build.py) e l'aggiunta al carrello di gioiello + collanina + ciondolino in un
     colpo solo (cart/add.js con items[], come il bundle sopra). Il totale sta su [data-gp-tot], che la barra fissa rispecchia.
     ------------------------------------------------------------------ */
  function euro(cents) { return '€' + (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function euroPiu(cents) { var n = cents / 100; return '+ €' + (n % 1 ? n.toLocaleString('it-IT', { minimumFractionDigits: 2 }) : n); }

  function initScheda(root) {
    if (!root || root.dataset.gpInit) return;
    root.dataset.gpInit = '1';
    var configEl = root.querySelector('[data-gg-pdp-config]');
    var config = configEl ? JSON.parse(configEl.textContent) : null;
    var idInput = root.querySelector('[data-gg-pdp-variant-id]');
    var form = root.querySelector('.gg-pdp-form');
    var cta = root.querySelector('[data-gg-pdp-atc]');
    var riep = root.querySelector('[data-gp-riep]');
    var titolo = (root.querySelector('.gp-testa h1') || {}).textContent || '';

    // la galleria: i pallini seguono lo scorrimento, il video della slide in vista parte, la lente apre la foto grande
    var bin = root.querySelector('[data-gp-gal]');
    if (bin) {
      var pallini = root.querySelectorAll('[data-gp-pallini] i');
      var agGal = function () {
        var i = Math.round(bin.scrollLeft / Math.max(1, bin.clientWidth));
        pallini.forEach(function (p, k) { p.classList.toggle('on', k === i); });
        bin.querySelectorAll('video').forEach(function (v) {
          var mio = Math.abs(v.closest('.gp-gal-slide').offsetLeft - bin.scrollLeft) < 10;
          if (mio && v.getAttribute('src')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      };
      bin.addEventListener('scroll', function () { window.requestAnimationFrame(agGal); }, { passive: true });
      var zoom = root.querySelector('[data-gp-zoom]');
      if (zoom) zoom.addEventListener('click', function () {
        var i = Math.round(bin.scrollLeft / Math.max(1, bin.clientWidth));
        var img = bin.querySelectorAll('.gp-gal-slide')[i] && bin.querySelectorAll('.gp-gal-slide')[i].querySelector('img');
        if (img) window.open(img.currentSrc || img.src, '_blank', 'noopener');
      });
    }

    // 7/10/2026 (blocco 3) · i passetti: la scelta accende il cerchio, scrive la proprietà e apre la foto in cui si vede quel passetto
    root.querySelectorAll('[data-gp-gruppo]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var c = e.target.closest('.gp-pf'); if (!c) return;
        g.querySelectorAll('.gp-pf').forEach(function (x) { x.classList.toggle('on', x === c); });
        var inp = g.querySelector('input[type="hidden"]'); if (inp) inp.value = c.dataset.n || '';
        if (c.dataset.foto && bin) { var s = bin.querySelectorAll('.gp-gal-slide')[Number(c.dataset.foto) - 1]; if (s) bin.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
      });
    });

    // 14/10/2026 · i passetti nel riquadro di Datti tempo: «Cambia ›» apre e chiude la fila dei tondi (come «La collana»), la scelta
    // riscrive il nome e il tondo della riga; la proprietà la scrive l'ascoltatore qui sopra
    var pas = root.querySelector('[data-gp-pas]');
    if (pas) pas.addEventListener('click', function (e) {
      var a = e.target.closest('.gp-upA-azione[data-apri]');
      if (a) {
        var p = pas.querySelector('.gp-upA-pannello[data-pannello="' + a.dataset.apri + '"]'); if (!p) return;
        p.hidden = !p.hidden; a.textContent = p.hidden ? 'Cambia ›' : 'Chiudi'; return;
      }
      var c = e.target.closest('.gp-pf'); if (!c) return;
      var pan = c.closest('.gp-upA-pannello'), riga = pan && pan.previousElementSibling; if (!riga) return;
      var nome = riga.querySelector('[data-gp-pas-nome]'); if (nome) nome.textContent = c.dataset.n || '';
      var mini = riga.querySelector('[data-gp-pas-mini]'), tondo = c.querySelector('.gp-pf-c');
      if (mini && tondo) { var im = tondo.querySelector('img'), mi = mini.querySelector('img'); if (im && mi) mi.src = im.currentSrc || im.src; else mini.style.background = tondo.style.background; }
    });

    // dove le scelte dei passetti sono del tema, Easify (nascosto) non deve più fermare il pulsante: l'aggiunta la fa lo script,
    // prima che il suo ascoltatore la veda (capture sul documento), con le proprietà del form
    if (root.querySelector('[data-gp-gruppo]') && form && cta) document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-gg-pdp-atc]') || !root.contains(e.target)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var base_label = cta.textContent; cta.classList.add('is-loading');
      fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); cta.textContent = 'Aggiunto ✓'; document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); })
        .catch(function () { cta.textContent = 'Riprova'; })
        .finally(function () { cta.classList.remove('is-loading'); setTimeout(function () { cta.textContent = base_label; }, 2500); });
    }, true);

    // 7/10/2026 (blocco 3) · il buono regalo: «A chi lo regali?» accende i campi del destinatario (e li spegne, così non viaggiano nell'ordine)
    var dest = root.querySelector('[data-gp-dest]'), destCampi = root.querySelector('[data-gp-dest-campi]');
    if (dest && destCampi) {
      var offset = destCampi.querySelector('[data-gp-dest-offset]'); if (offset) offset.value = new Date().getTimezoneOffset();
      var data = destCampi.querySelector('[data-gp-dest-data]');
      if (data) { var oggi = new Date(), fra = new Date(Date.now() + 90 * 864e5); var iso = function (d) { return d.toISOString().slice(0, 10); }; data.min = iso(oggi); data.max = iso(fra); }
      dest.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-dest]'); if (!b) return;
        dest.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === b); });
        var lei = b.dataset.dest === 'lei';
        destCampi.hidden = !lei;
        destCampi.querySelectorAll('input, textarea').forEach(function (c) { c.disabled = !lei; });
        var ck = destCampi.querySelector('[data-gp-dest-check]'); if (ck) ck.checked = lei;
        destCampi.querySelectorAll('input[type="email"], input[type="text"]').forEach(function (c) { c.required = lei; });
        if (lei) { var primo = destCampi.querySelector('input[type="text"]'); if (primo) primo.focus(); }
      });
    }

    // «Dettagli in» Oro / Argento → properties[Dettagli]
    var fin = root.querySelector('[data-gp-fin]');
    var finInput = root.querySelector('[data-gp-fin-input]');
    if (fin) fin.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]'); if (!b) return;
      fin.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === b); });
      if (finInput) finInput.value = b.dataset.v;
    });
    // 16/10/2026 (Claude, punto 32; Luca: «ok per testa tra le nuvole»): tornando dalla tendina o dalla pagina del carrello il link porta
    // &dettagli=Argento: si riaccende la scelta che sta nel carrello, invece di Oro (lo scrive snippets/cart-drawer-item.liquid)
    var dettUrl = new URLSearchParams(window.location.search).get('dettagli');
    if (fin && dettUrl) fin.querySelectorAll('button[data-v]').forEach(function (b) { if (b.dataset.v === dettUrl) b.click(); });

    // la base: il prezzo della variante scelta (il tema lo scrive in [data-gg-pdp-price]; la variante è nell'input nascosto)
    function base() {
      if (config && idInput) {
        // 10/10/2026: col cambio della collana (data-gp-cambio = la variante della collana compresa) si parte sempre da lì,
        // e la differenza della collana scelta sta in st.collP — così il totale è il prezzo della variante scelta
        var idCalc = (look && look.dataset.gpCambio) || idInput.value;
        var v = config.variants.find(function (x) { return String(x.id) === String(idCalc); });
        if (v) return v.price;
      }
      return 0;
    }

    var look = root.querySelector('[data-gp-look]');
    var st = { collId: '', collP: 0, collN: '', cioId: '', cioP: 0, cioN: '' };
    var cambio = !!(look && look.dataset.gpCambio);
    function nomeCollana() { return st.collN ? st.collN.charAt(0).toUpperCase() + st.collN.slice(1) : ''; }
    function agg() {
      var tot = base() + st.collP + st.cioP;
      root.querySelectorAll('[data-gp-tot]').forEach(function (e) { e.textContent = euro(tot); });
      var imp = root.querySelector('[data-gp-gc-imp]'); if (imp) { var n = base() / 100; imp.textContent = '€' + (n % 1 ? n.toLocaleString('it-IT', { minimumFractionDigits: 2 }) : n); }
      if (cta && !cta.disabled) cta.textContent = (cta.dataset.labelDefault || 'Aggiungi al carrello') + ' · ' + euro(tot);
      if (riep) {
        var parti = [titolo.trim() + ' ' + euro(base())];
        if (st.collN) parti.push(nomeCollana().toLowerCase() + ' ' + (st.collP ? euro(st.collP) : 'compresa'));
        if (st.cioN) parti.push('ciondolino ' + st.cioN.toLowerCase() + ' ' + euro(st.cioP));
        riep.textContent = parti.join('  +  ');
        riep.hidden = parti.length < 2;
      }
      if (!look) return;
      var rc = look.querySelector('[data-gp-riga-collana]'), rk = look.querySelector('[data-gp-riga-cio]');
      if (rc) rc.innerHTML = st.collN ? nomeCollana() + ' · ' + (st.collP ? '<em class="piu">' + euroPiu(st.collP) + '</em>' : '<em class="ok">compresa</em>') : rc.dataset.baseNome + (rc.dataset.baseAgg ? ' · <em class="ok">' + rc.dataset.baseAgg + '</em>' : '');
      if (rk) rk.innerHTML = st.cioN ? st.cioN + ' · <em class="piu">' + euroPiu(st.cioP) + '</em>' : 'Nessuno · <em>da + ' + rk.dataset.da + '</em>';
      var bc = look.querySelector('[data-gp-badge-collana]'), bk = look.querySelector('[data-gp-badge-cio]');
      if (bc) bc.hidden = !st.collN; if (bk) bk.hidden = !st.cioN;
      look.querySelectorAll('.gp-upA-riga').forEach(function (r) {
        r.classList.toggle('scelta', r.dataset.riga === 'collana' ? !!st.collN : !!st.cioN);
      });
      look.querySelectorAll('.gp-upA-azione[data-apri]').forEach(function (a) {
        var p = look.querySelector('.gp-upA-pannello[data-pannello="' + a.dataset.apri + '"]'); if (!p) return;
        var scelto = a.dataset.apri === 'collana' ? !!st.collN : !!st.cioN;
        if (!p.hidden) { a.textContent = 'Chiudi'; a.classList.remove('grigia'); return; }
        a.textContent = a.dataset.apri === 'collana' || scelto ? 'Cambia ›' : 'Aggiungi ›';
        a.classList.toggle('grigia', scelto);
      });
    }

    // 16/10/2026 (Claude, punto 16 del test da iPhone): il pannello che si apre sotto la riga spinge «Aggiungi al carrello» fuori
    // dallo schermo, compare la barra fissa e lo copre tutto (su Sei casa il tocco sulla Coccinella prendeva la barra, ed entrava
    // Sei casa senza ciondolino). Aperto un pannello, la pagina sale quanto basta perché stia intero sopra la barra, senza portare
    // la sua riga sotto la testata; se si vede già tutto, non si muove niente.
    function mostraPannello(p) {
      window.requestAnimationFrame(function () {
        var bar = document.querySelector('.gg-pdp-cartbar');
        var giu = p.getBoundingClientRect().bottom - (window.innerHeight - (bar ? bar.offsetHeight || 80 : 0) - 12);
        if (giu <= 0) return;
        var testa = 0, el = document.elementFromPoint(window.innerWidth / 2, 2);
        while (el && el !== document.body) {
          var pos = window.getComputedStyle(el).position;
          if (pos === 'fixed' || pos === 'sticky') { testa = el.getBoundingClientRect().bottom; break; }
          el = el.parentElement;
        }
        var riga = p.previousElementSibling;
        var su = riga ? riga.getBoundingClientRect().top - testa - 8 : giu;
        window.scrollBy({ top: Math.max(0, Math.min(giu, su)), behavior: 'smooth' });
      });
    }

    if (look) {
      var fotoC = look.querySelector('[data-gp-foto-collana]'), fotoK = look.querySelector('[data-gp-foto-cio]');
      look.addEventListener('click', function (e) {
        var a = e.target.closest('.gp-upA-azione[data-apri]');
        if (a) { var p = look.querySelector('.gp-upA-pannello[data-pannello="' + a.dataset.apri + '"]'); if (p) p.hidden = !p.hidden; agg(); if (p && !p.hidden) mostraPannello(p); return; }
        var chip = e.target.closest('.gp-chip[data-k]');
        if (chip) {
          look.querySelectorAll('.gp-chip[data-k]').forEach(function (c) { c.classList.toggle('on', c === chip); });
          st.collId = ''; st.collP = 0; st.collN = '';
          look.querySelectorAll('.gp-colori').forEach(function (g) {
            var mio = g.dataset.per === chip.dataset.k && chip.dataset.k !== '';
            g.hidden = !mio;
            g.querySelectorAll('.gp-colore').forEach(function (c) { c.classList.remove('on'); });
            if (mio) { var primo = g.querySelector('.gp-colore:not([data-esaurito])') || g.querySelector('.gp-colore'); if (primo) scegliColore(primo); }
          });
          if (chip.dataset.k === '' && fotoC) fotoC.src = fotoC.dataset.srcBase;
          if (cambio && idInput && chip.dataset.k === '') idInput.value = look.dataset.gpCambio;
          agg(); return;
        }
        var col = e.target.closest('.gp-colore');
        if (col) { scegliColore(col); agg(); return; }
        var cio = e.target.closest('.gp-cio');
        if (cio) {
          var togli = cio.classList.contains('on') && cio.dataset.n;
          look.querySelectorAll('.gp-cio').forEach(function (c) { c.classList.toggle('on', !togli && c === cio); });
          if (togli || !cio.dataset.n) { var nes = look.querySelector('.gp-cio[data-n=""]'); if (nes) nes.classList.add('on'); st.cioId = ''; st.cioP = 0; st.cioN = ''; }
          else { st.cioId = cio.dataset.id; st.cioP = Number(cio.dataset.p); st.cioN = cio.dataset.n; if (fotoK && cio.dataset.img) fotoK.src = cio.dataset.img; }
          agg(); return;
        }
      });
      var scegliColore = function (el) {
        el.parentElement.querySelectorAll('.gp-colore').forEach(function (c) { c.classList.toggle('on', c === el); });
        st.collId = el.dataset.id; st.collP = Number(el.dataset.p); st.collN = el.dataset.n;
        if (cambio) { if (idInput) idInput.value = el.dataset.id; st.collId = ''; }
        if (fotoC && el.dataset.img) fotoC.src = el.dataset.img;
      };
    }

    // quando il tema cambia variante riscrive prezzo e pulsante: si rifanno i conti subito dopo
    var prezzoTema = root.querySelector('[data-gg-pdp-price]');
    if (prezzoTema && 'MutationObserver' in window) new MutationObserver(function () { window.requestAnimationFrame(agg); }).observe(prezzoTema, { childList: true, characterData: true, subtree: true });

    // l'aggiunta al carrello: gioiello + collanina + ciondolino in un colpo solo (solo se c'è qualcosa in più, altrimenti fa il tema)
    if (form && cta) form.addEventListener('submit', function (evt) {
      if (!st.collId && !st.cioId) return;
      evt.preventDefault(); evt.stopImmediatePropagation();
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var main = { id: Number(idInput.value), quantity: 1 }, props = {}, bloccato = false;
      form.querySelectorAll('[name^="properties["]').forEach(function (campo) {
        var nome = campo.name.slice(11, -1), valore = (campo.value || '').trim();
        if (campo.required && !valore) { campo.focus(); campo.classList.add('is-error'); bloccato = true; return; }
        if (valore) props[nome] = valore;
      });
      if (bloccato) return;
      // 10/10/2026 (Luca): collana e ciondolino scelti dalla scheda vanno nel carrello come righe a sé, ognuna col suo prezzo e il suo
      // «Rimuovi» (provato per un giro come _bundle:look legato al gioiello, poi scartato: «per le Frasi lo lascerei così, per gli altri
      // prodotti se uno sceglie un upsell lo metterei come altra riga»). Solo le Frasi restano raggruppate.
      if (Object.keys(props).length) main.properties = props;
      // il carrello mostra in cima l'ultima riga aggiunta: il gioiello va per ultimo, così compare primo, poi la collana, poi il ciondolo
      var items = [];
      if (st.cioId) items.push({ id: Number(st.cioId), quantity: 1 });
      if (st.collId) items.push({ id: Number(st.collId), quantity: 1 });
      items.push(main);
      var base_label = cta.textContent;
      cta.classList.add('is-loading');
      fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); cta.textContent = 'Aggiunto ✓'; document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); })
        .catch(function () { cta.textContent = 'Riprova'; })
        .finally(function () { cta.classList.remove('is-loading'); setTimeout(function () { cta.textContent = base_label; }, 2500); });
    }, true);

    // 12/10/2026 · il buono: la barra dell'importo (Luca, la C fra tre prove — lavoro/mockup-buono-importo-12-10.js). Si ferma sul taglio
    // più vicino fra quelli che il prodotto ha davvero e tocca la sua pillola, anche se è nascosta: variante, prezzo, cartoncino e pulsante
    // seguono come con un tocco. Toccando una scorciatoia, la barra la segue. «di 5 in 5» si scrive solo se i tagli sono davvero uno ogni 5 €.
    var barra = root.querySelector('[data-gp-gc-barra]');
    if (barra && config) {
      var rng = barra.querySelector('[data-gp-gc-range]'), impB = barra.querySelector('[data-gp-gc-barra-imp]');
      var grp = root.querySelector('[data-gg-pdp-option="1"]');
      var tagli = config.variants.filter(function (v) { return v.available; })
        .map(function (v) { return { e: v.price / 100, val: v.option1 }; }).sort(function (a, b) { return a.e - b.e; });
      var passo = tagli.length > 1 ? tagli[1].e - tagli[0].e : 0;
      var regolare = passo > 0 && tagli.every(function (t, i) { return i === 0 || t.e - tagli[i - 1].e === passo; });
      var passoEl = barra.querySelector('[data-gp-gc-passo]'); if (passoEl && regolare) passoEl.textContent = 'di ' + passo + ' in ' + passo;
      var vicino = function (n) { return tagli.reduce(function (a, t) { return Math.abs(t.e - n) < Math.abs(a.e - n) ? t : a; }, tagli[0]); };
      var dipingi = function (e) {
        var mn = +rng.min, mx = +rng.max, p = mx > mn ? (e - mn) / (mx - mn) * 100 : 0;
        rng.value = e; rng.style.setProperty('--gp-p', p + '%');
        if (impB) impB.textContent = '€' + e;
      };
      var scegli = function (t) {
        dipingi(t.e);
        var b = grp && [].find.call(grp.querySelectorAll('.gp-pill'), function (x) { return x.dataset.value === t.val; });
        if (b && !b.classList.contains('is-selected')) b.click();
      };
      if (tagli.length) {
        // il taglio si sceglie già mentre si trascina: Safari da iPhone non sempre manda «change» alla fine (provato col motore WebKit, 12/10)
        rng.addEventListener('input', function () { scegli(vicino(+rng.value)); });
        rng.addEventListener('change', function () { scegli(vicino(+rng.value)); });
        if (grp) grp.addEventListener('click', function (e) {
          var b = e.target.closest('.gp-pill'); if (!b) return;
          var t = tagli.find(function (x) { return x.val === b.dataset.value; }); if (t) dipingi(t.e);
        });
        var sel = grp && grp.querySelector('.gp-pill.is-selected');
        var t0 = sel && tagli.find(function (x) { return x.val === sel.dataset.value; });
        dipingi(t0 ? t0.e : +rng.value);
      }
    }

    // col cambio, se la pagina si apre su un'altra collana (?variant= dal carrello) si accendono il suo tipo e il suo colore
    if (cambio && idInput && idInput.value !== look.dataset.gpCambio) {
      var giaScelta = look.querySelector('.gp-colore[data-id="' + idInput.value + '"]');
      var tipoScelto = giaScelta && look.querySelector('.gp-chip[data-k="' + giaScelta.parentElement.dataset.per + '"]');
      if (tipoScelto) { tipoScelto.click(); giaScelta.click(); }
    }
    agg();
  }

  function bootScheda() { document.querySelectorAll('[data-gp-scheda]').forEach(initScheda); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootScheda); else bootScheda();


  /* 7/10/2026 (blocco 4) · i form marcati data-gg-ajax fuori dalla scheda (il blocco dell'acquisto di Crea il tuo gioiello, gg-crea-buy):
     l'aggiunta va via cart/add.js e apre la tendina, come le altre schede. Prima facevano il submit nativo e finivano sulla pagina /cart. */
  function initFormAjax(form) {
    if (form.dataset.ggAjaxInit) return; form.dataset.ggAjaxInit = '1';
    form.addEventListener('submit', function (evt) {
      evt.preventDefault(); evt.stopImmediatePropagation();
      var cta = form.querySelector('button[type="submit"]'), base_label = cta ? cta.textContent : '';
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (cta) cta.classList.add('is-loading');
      fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); if (cta) cta.textContent = 'Aggiunto ✓'; document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); })
        .catch(function () { if (cta) cta.textContent = 'Riprova'; })
        .finally(function () { if (cta) { cta.classList.remove('is-loading'); setTimeout(function () { cta.textContent = base_label; }, 2500); } });
    }, true);
  }
  function bootAjax() { document.querySelectorAll('form[data-gg-ajax]').forEach(initFormAjax); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAjax); else bootAjax();

  // le file di card «Ti potrebbe piacere»: frecce e contatore veri (come gg-home.js)
  function initScorri(sc) {
    var pag = sc.parentElement.querySelector('[data-gp-pag]'); if (!pag || sc.dataset.gpSc) return; sc.dataset.gpSc = '1';
    var conta = pag.querySelector('[data-gp-conta]'), prev = pag.querySelector('[data-gp-prev]'), next = pag.querySelector('[data-gp-next]');
    function n() { return sc.querySelectorAll('.gp-card').length; }
    function passo() { var c = sc.querySelector('.gp-card'); if (!c) return sc.clientWidth; var cs = window.getComputedStyle(sc); return c.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 0); }
    function agg() { var i = Math.min(n() - 1, Math.max(0, Math.round(sc.scrollLeft / passo()))); if (conta) conta.textContent = (i + 1) + '/' + n(); if (prev) prev.classList.toggle('gp-off', sc.scrollLeft <= 2); if (next) next.classList.toggle('gp-off', sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2); }
    if (prev) prev.addEventListener('click', function () { sc.scrollBy({ left: -passo(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { sc.scrollBy({ left: passo(), behavior: 'smooth' }); });
    sc.addEventListener('scroll', function () { window.requestAnimationFrame(agg); }, { passive: true }); agg();
  }
  function bootScorri() { document.querySelectorAll('.ggp [data-gp-scorri]').forEach(initScorri); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootScorri); else bootScorri();
})();

/* 12/10/2026 (Claude, versione desktop) · le frecce ai lati della foto e i pallini cliccabili, per chi arriva col mouse. Su telefono le frecce
   sono nascoste (gg-pdp.css) e i pallini non ricevono il click (pointer-events:none), quindi lì non cambia niente. Vale per le tre gallerie
   (scheda, animaletto, Crea il tuo gioiello): stesso markup .gp-gal-grande > .gp-gal-binario + .gp-gal-pallini. All'ultima foto «avanti»
   torna alla prima. */
(function () {
  function avvia() {
    document.querySelectorAll('.gp-gal-grande').forEach(function (g) {
      var bin = g.querySelector('.gp-gal-binario'); if (!bin) return;
      var slide = function () { return bin.querySelectorAll('.gp-gal-slide'); };
      var vaiA = function (k) { var s = slide()[k]; if (s) bin.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); };
      g.querySelectorAll('[data-gg-freccia]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = slide().length; if (!n) return;
          var i = Math.round(bin.scrollLeft / Math.max(1, bin.clientWidth));
          vaiA((i + Number(b.getAttribute('data-gg-freccia')) + n) % n);
        });
      });
      g.querySelectorAll('.gp-gal-pallini i').forEach(function (p, k) { p.addEventListener('click', function () { vaiA(k); }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();

/* 13/10/2026 (Luca: «se uno tocca questa parte con il dito lo porti in questa sezione») · la riga delle stelle sotto il titolo
   («★★★★★ 4,98 169 recensioni · Verificate», a.gp-fascia-mini) porta al carosello «Le recensioni» di Judge.me. Il link era già #recensioni,
   ma l'ancora c'è solo nelle Frasi: il carosello è un blocco dell'app e dal tema non gli si dà un id. Qui si cerca il carosello
   (.jdgm-cards-carousel, uguale in tutte le schede) e ci si scorre sopra col titolo in vista; se non c'è, resta il salto normale a #recensioni.
   Le foto più su che si caricano durante lo scorrimento possono spostarlo: a fine corsa si ricontrolla e, se serve, si corregge.
   Alcune schede caricano questo file due volte: il click si aggancia una volta sola. */
(function () {
  if (window.ggVaiRecensioni) return;
  window.ggVaiRecensioni = true;
  // 27/10/2026 (task 10 del post go live): si toglie anche l'altezza della testata fissa (--f-header-height), che copriva il titolo
  // «Le recensioni» e il voto
  function testata() { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--f-header-height')) || 0; }
  function dove(c) { return c.getBoundingClientRect().top + window.pageYOffset - testata() - 16; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#recensioni"]');
    if (!a) return;
    var c = document.querySelector('.jdgm-cards-carousel');
    if (!c) return;
    e.preventDefault();
    window.scrollTo({ top: dove(c), behavior: 'smooth' });
    setTimeout(function () { var y = dove(c); if (Math.abs(window.pageYOffset - y) > 30) window.scrollTo({ top: y }); }, 1000);
  });
})();

/* 16/10/2026 (Claude, punto 17 del test da iPhone; Luca: «sì, procedi così nella bozza») · nelle righe «Cambia ›» / «Aggiungi ›»
   (La collana, Un ciondolino, i passetti, la targhetta e la collana dell'animaletto) rispondeva solo la scritta a destra: il tocco sul
   nome, sulla fotina o sul prezzo non faceva niente, ed era il tocco a vuoto di Clarity. Ora tutta la riga fa quello che fa la scritta,
   tranne quando la scritta dice «Togli» (la targhetta già aggiunta): un tocco distratto non toglie mai una scelta.
   Alcune schede caricano questo file due volte: il click si aggancia una volta sola, altrimenti il pannello si aprirebbe e richiuderebbe. */
(function () {
  if (window.ggRigaIntera) return;
  window.ggRigaIntera = true;
  document.addEventListener('click', function (e) {
    var riga = e.target.closest && e.target.closest('.gp-upA-riga');
    if (!riga || e.target.closest('button, a, input, select, textarea, label')) return;
    var az = riga.querySelector('.gp-upA-azione');
    if (!az || az.hidden || az.disabled || /^Togli/.test(az.textContent.trim())) return;
    az.click();
  });
  function manina() { document.querySelectorAll('.gp-upA-riga').forEach(function (r) { r.style.cursor = 'pointer'; }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', manina); else manina();
})();
